import React from 'react';
import { Users, Building, UserCheck, TrendingUp, Package, CreditCard } from 'lucide-react';
import { FormatUtils } from '../shared/FormatUtils.jsx';

const ClientStats = ({ clients, products }) => {
    // Calculate statistics
    const stats = {
        total: clients.length,
        retail: clients.filter(c => c.clientType === 'RETAIL').length,
        corporate: clients.filter(c => c.clientType === 'CORPORATE').length,
        withConsent: clients.filter(c => c.crossSellingConsent).length,
        activeClients: clients.filter(c => c.active !== false).length,
        avgProductsPerClient: clients.length > 0
            ? (clients.reduce((sum, c) => sum + (c.clientProducts?.length || 0), 0) / clients.length)
            : 0
    };

    const consentRate = stats.total > 0 ? ((stats.withConsent / stats.total) * 100) : 0;
    const activeRate = stats.total > 0 ? ((stats.activeClients / stats.total) * 100) : 0;

    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-4 mb-6">
            <StatCard
                icon={Users}
                label="Total Clients"
                value={stats.total.toLocaleString()}
                color="blue"
            />
            <StatCard
                icon={Users}
                label="Retail"
                value={stats.retail.toLocaleString()}
                color="green"
            />
            <StatCard
                icon={Building}
                label="Corporate"
                value={stats.corporate.toLocaleString()}
                color="purple"
            />
            <StatCard
                icon={UserCheck}
                label="Active"
                value={FormatUtils.formatPercentage(activeRate, 0)}
                subtitle={`${stats.activeClients.toLocaleString()} clients`}
                color="emerald"
            />
            <StatCard
                icon={TrendingUp}
                label="Consent Rate"
                value={FormatUtils.formatPercentage(consentRate, 0)}
                subtitle={`${stats.withConsent.toLocaleString()} clients`}
                color="yellow"
            />
            <StatCard
                icon={Package}
                label="Avg Products"
                value={stats.avgProductsPerClient.toFixed(1)}
                subtitle="per client"
                color="indigo"
            />
        </div>
    );
};

const StatCard = ({ icon: Icon, label, value, subtitle, color }) => {
    const colorClasses = {
        blue: 'bg-blue-100 text-blue-600',
        green: 'bg-green-100 text-green-600',
        purple: 'bg-purple-100 text-purple-600',
        emerald: 'bg-emerald-100 text-emerald-600',
        yellow: 'bg-yellow-100 text-yellow-600',
        indigo: 'bg-indigo-100 text-indigo-600'
    };

    return (
        <div className="bg-white rounded-lg border border-gray-200 p-4">
            <div className="flex items-center gap-3 mb-2">
                <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${colorClasses[color]}`}>
                    <Icon className="w-5 h-5" />
                </div>
                <div className="flex-1">
                    <p className="text-xs text-gray-500">{label}</p>
                    <p className="text-xl font-bold text-gray-900">{value}</p>
                    {subtitle && <p className="text-xs text-gray-500">{subtitle}</p>}
                </div>
            </div>
        </div>
    );
};

export default ClientStats;
